module.exports = __webpack_public_path__ + "img/stock0.3eb937ca.png";